export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()

    // If no GA ID is set, skip loading
    if (!config.public.gaMeasurementId) {
        console.warn('GA plugin: no GA ID found, skipping.')
        return
    }

    // 1) Insert GA script
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${config.public.gaMeasurementId}`
    document.head.appendChild(script)

    // 2) Initialize GA
    window.dataLayer = window.dataLayer || []
    function gtag() {
        window.dataLayer.push(arguments)
    }
    window.gtag = gtag

    gtag('js', new Date())
    gtag('config', config.public.gaMeasurementId)
})
